import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { UpdateCompanyDataComponent } from './update-company-data.component';

@Injectable({
  providedIn: 'root',
})
export class UpdateCompanyDataService {
  constructor(private dialog: MatDialog) {}

  open(config: MatDialogConfig = new MatDialogConfig()): Observable<string> {
    config.position = { right: '0px' };

    const dialogRef = this.dialog.open(UpdateCompanyDataComponent);

    return dialogRef.afterClosed();
  }
}
